import React from "react";
import Header from "./Header";

function PrivacyPolicyPage() {
  return (
    <>
      <Header />
      <main style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0f172a 0%, #111827 100%)", color: "#e5eefb", padding: "32px 18px 64px" }}>
        <div style={{ maxWidth: 980, margin: "0 auto", background: "rgba(15, 23, 42, 0.78)", border: "1px solid rgba(148, 163, 184, 0.18)", borderRadius: 24, boxShadow: "0 18px 48px rgba(15, 23, 42, 0.35)", padding: "28px" }}>
          <p style={{ marginBottom: 10, color: "#bfdbfe", fontSize: 13, textTransform: "uppercase", letterSpacing: "0.18em" }}>Kriva Bharat Mail</p>
          <h1 style={{ margin: "0 0 8px", fontSize: 32, color: "#fff" }}>Privacy Policy</h1>
          <p style={{ color: "#dbe5f5", lineHeight: 1.6, marginBottom: 20 }}>
            This Privacy Policy explains how we collect, use, store, and protect your information when you use Kriva Bharat Mail.
          </p>

          <section style={{ marginBottom: 18 }}>
            <h2 style={{ fontSize: 18, color: "#fff", marginBottom: 8 }}>1. Information We Collect</h2>
            <p style={{ color: "#dbe5f5", lineHeight: 1.6, margin: 0 }}>
              We collect the information you provide during signup and login, including your name, email address, password, and recovery details. We also collect usage data needed to operate the service securely and improve performance.
            </p>
          </section>

          <section style={{ marginBottom: 18 }}>
            <h2 style={{ fontSize: 18, color: "#fff", marginBottom: 8 }}>2. How We Use Your Information</h2>
            <p style={{ color: "#dbe5f5", lineHeight: 1.6, margin: 0 }}>
              Your information is used to create and maintain your account, authenticate access, send service notifications, support recovery options, and improve the platform experience.
            </p>
          </section>

          <section style={{ marginBottom: 18 }}>
            <h2 style={{ fontSize: 18, color: "#fff", marginBottom: 8 }}>3. Data Sharing</h2>
            <p style={{ color: "#dbe5f5", lineHeight: 1.6, margin: 0 }}>
              We do not sell your personal data. We may share limited information with trusted service providers only to operate the platform, comply with legal requirements, or protect the security of our users.
            </p>
          </section>

          <section style={{ marginBottom: 18 }}>
            <h2 style={{ fontSize: 18, color: "#fff", marginBottom: 8 }}>4. Security</h2>
            <p style={{ color: "#dbe5f5", lineHeight: 1.6, margin: 0 }}>
              We use reasonable administrative, technical, and physical safeguards to protect your account and data. However, no system is completely risk-free, so please keep your password secure and update it regularly.
            </p>
          </section>

          <section style={{ marginBottom: 24 }}>
            <h2 style={{ fontSize: 18, color: "#fff", marginBottom: 8 }}>5. Your Choices</h2>
            <p style={{ color: "#dbe5f5", lineHeight: 1.6, margin: 0 }}>
              You may review, update, or request deletion of your account information where applicable. Please contact support if you need help with privacy-related requests.
            </p>
          </section>

          <a
            href="/login"
            style={{
              display: "inline-block",
              textDecoration: "none",
              color: "#eff6ff",
              background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
              padding: "10px 16px",
              borderRadius: 10,
              fontWeight: 700,
            }}
          >
            Back to Login
          </a>
        </div>
      </main>
    </>
  );
}

export default PrivacyPolicyPage;
